<script>
export default {
  name: "unifiButton",
  data:{

  },
  methods: {
    handleClick() {
      this.$emit('onClick');
    }
  },
  props: {
    label: String,
    type: String,
    className: String

  },
  computed: {
    dynamicClass() {
      return "unifi-btn " + this.className;

    },

  }
};

</script>

<template>
  <div class="unifi-btn-wrapper">
    <el-button :class="dynamicClass" @click="handleClick">{{label}}  </el-button>
  </div>

</template>

<style lang="css">
.unifi-btn-wrapper{
  .unifi-btn{
    font-feature-settings: "clig" off, "liga" off;
    border-radius: 5px;
    padding: 15px 60px;
    height: max-content;
    font: 500 20px DINosaur-a, sans-serif;
    margin-right: auto;
  }
  .btn-primary{
    background: #003333;
    color: #ffffff;
  }
  .btn-default{
    color: #003333;
  }
  .el-button:hover {
    opacity: 0.8;
    transform: scale(1.05); /* Slightly enlarge button on hover */
    color: #003333;
    border-color: #003333;
    background-color: #ffffff;
  }
  .el-button:focus {
    outline: 2px solid #003333; /* Outline for accessibility */
    color: #003333;
    border-color: #003333;
    background-color: #ffffff;
  }
  /* Animation for the button click */
  button.button-clicked {
    animation: clickAnimation 0.2s ease;
  }
  @keyframes clickAnimation {
    0% {
      transform: scale(0.95);
    }
    100% {
      transform: scale(1);
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/common/unifiButton.vue